import { render, staticRenderFns } from "./MyColorPicker.vue?vue&type=template&id=2c12c494&scoped=true&"
import script from "./MyColorPicker.vue?vue&type=script&lang=js&"
export * from "./MyColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c12c494",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c12c494')) {
      api.createRecord('2c12c494', component.options)
    } else {
      api.reload('2c12c494', component.options)
    }
    module.hot.accept("./MyColorPicker.vue?vue&type=template&id=2c12c494&scoped=true&", function () {
      api.rerender('2c12c494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyColorPicker.vue"
export default component.exports